import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Box, Typography } from '@material-ui/core';
import FormHeader from 'components/FormComponents/FormHeader';
import Modal from 'components/ModalV2';
import Button from 'components/V2/Button';
import PropTypes from 'prop-types';

import { showHostfullyGuidePreview } from 'redux/actions/settings';

import styles from './guidePreview.module.css';

import hostfullyGuide from 'asset/img/hostfully-guide.svg';

function GuidePreview({ showHostfullyGuidePreview, hostfullyGuidePreview }) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!hostfullyGuidePreview) {
            setOpen(true);
        }
    }, [hostfullyGuidePreview, setOpen, showHostfullyGuidePreview]);

    const handleClose = () => {
        setOpen(false);
        showHostfullyGuidePreview();
    };

    const handleAccess = () => {
        window.open(
            'https://sandbox.hostfully.com/app/#/l/integrations%2Fdefault%2Fintegration.jsp?enumId=authenticate',
            '_blank'
        );
    };

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            disableBackdropClick
            className={styles.previewModal}
        >
            <Box>
                <FormHeader
                    className="{styles.previewHeaderClose}"
                    title=""
                    handleClose={handleClose}
                />
                <Box className={styles.previewHeader}>
                    <img
                        src={hostfullyGuide}
                        alt="hostfully Guide Preview GIF"
                        className={styles.previewAnimation}
                    />
                    <Box className={styles.previewTextContainer}>
                        <Typography className={styles.previewText}>
                            To import listings on Authenticate, please enable
                            <br />
                            access by switching the toggle to ON.
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Box className={styles.btnGroup}>
                <Button
                    intent="secondary"
                    size="lg"
                    onClick={handleClose}
                    className={styles.previewBtn}
                >
                    Cancel
                </Button>
                <Button
                    intent="primary"
                    size="lg"
                    onClick={handleAccess}
                    className={styles.previewBtn}
                >
                    Enable Access
                </Button>
            </Box>
        </Modal>
    );
}

GuidePreview.propTypes = {
    hostfullyGuidePreview: PropTypes.func,
    showHostfullyGuidePreview: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        hostfullyGuidePreview: state.settings?.hostfullyGuidePreview,
    };
}

export default connect(mapStateToProps, { showHostfullyGuidePreview })(GuidePreview);
